/**
 * StubPage.js
 * A generic placeholder page for "Coming Soon" features.
 * Wraps content in TeacherLayout to preserve navigation context.
 */

import React from 'react';
import { Construction } from 'lucide-react';
import TeacherLayout from './teacher/layout/TeacherLayout';

const StubPage = ({ title, message = "This feature is coming soon!" }) => {
    return (
        <TeacherLayout title={title}>
            <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6">
                <div className="w-20 h-20 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-6 text-gray-400 dark:text-gray-500">
                    <Construction size={40} />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                    {title}
                </h2>
                <p className="text-gray-600 dark:text-gray-400 max-w-sm mx-auto">
                    {message}
                </p>
                <div className="mt-8 p-4 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 rounded-lg text-sm max-w-md">
                    We are working hard to build this feature for you. Stay tuned for updates!
                </div>
            </div>
        </TeacherLayout>
    );
};

export default StubPage;
